export function emptyFetch() {
   console.log('emptyFetch')
}